import { sanitizeInput } from "./sanitize";
import { REFERRAL_CODE_STORAGE_KEY } from "./updateReferralCodeFromUrl";

const getMycoins = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const referralcodeFromUrl = sanitizeInput(urlParams.get("referralcode"));

  const referralcode =
    referralcodeFromUrl && referralcodeFromUrl !== "null"
      ? referralcodeFromUrl
      : sanitizeInput(localStorage.getItem(REFERRAL_CODE_STORAGE_KEY));

  return referralcode;
};

export default getMycoins;
